module.exports = __webpack_public_path__ + "static/media/portfolio-8.880dd428.jpg";